module.exports = __webpack_public_path__ + "7dcb6ae4e30fdbbbfa7bbc6a3914be3d.svg";